import "./NftStaking.scss"
import React, { useState, useEffect, useMemo } from "react"
import { Box } from "@mui/material"
import { NftDetails, NftDetailsItem } from "./types"
import { MAX_NFT_SELECTABLE } from "src/constants/boostFarm"
import { sortNftByRank } from "./utils"

import Text from "../Text"
import { Nft } from "./Nft"

interface NftSelectorViewProps {
  dataList: NftDetails[]
  selectedNftIds?: string[]
  maxSelect?: number
  onChange?: (newSelectedNfts: NftDetailsItem[]) => void
}

const NftSelectorView: React.FC<NftSelectorViewProps> = ({
  dataList,
  selectedNftIds,
  maxSelect = MAX_NFT_SELECTABLE,
  onChange,
}) => {
  const [nftsList, setNftsList] = useState<NftDetailsItem[]>([])
  const selectedCount = nftsList.filter((item) => item.selected).length

  useEffect(() => {
    if (dataList) {
      setNftsList(
        sortNftByRank(dataList).map(
          (nft) =>
            ({
              ...nft,
              selected: selectedNftIds && selectedNftIds.includes(nft.id),
            } as NftDetailsItem),
        ),
      )
    } else {
      setNftsList([])
    }
  }, [dataList, selectedNftIds])

  const renderContent = useMemo(() => {
    return nftsList?.map((item) => {
      return (
        <Nft
          key={item.id}
          id={item.id}
          imgUrl={item.imgUrl}
          selected={item.selected}
          disabled={!item.selected && selectedCount >= maxSelect}
          onClick={() => {
            if (selectedCount >= maxSelect && !item.selected) {
              return
            }
            const updatedNftList = nftsList.map((nft) => {
              if (nft.id === item.id) {
                return { ...nft, selected: !nft.selected }
              }
              return nft
            })
            setNftsList(updatedNftList)
            const newSelectedNfts = updatedNftList.filter((nft) => nft.selected)
            onChange && onChange(newSelectedNfts)
          }}
        />
      )
    })
  }, [maxSelect, nftsList, onChange, selectedCount])

  return (
    <Box>
      <Box mb={3} gap="4px">
        <Text>Select NFTs you want to stake</Text>
        <Text size="micro">
          Select up to 10 Cronos Cruisers NFTs to further boost your pool APR.
          NFTs of higher rarity will give higher Boost Power.
        </Text>
      </Box>
      <Box className="wrapper">{renderContent}</Box>
    </Box>
  )
}

export default NftSelectorView
